class BubblehouseValueMoney extends HTMLElement {
  constructor() {
    super();
    this.isInitialized = false;

    this.handleBubblehouseLoad = this.handleBubblehouseLoad.bind(this);

    document.addEventListener('bubblehouse:load', this.handleBubblehouseLoad);

    if (window.Bubblehouse && window.Bubblehouse.data && window.Bubblehouse.data.authToken) {
      this.loadMonetaryBalance();
    }
  }

  connectedCallback() {
    if (!this.isInitialized) {
      this.initialize();
    }
  }

  disconnectedCallback() {
    document.removeEventListener('bubblehouse:load', this.handleBubblehouseLoad);
  }

  initialize() {
    this.isInitialized = true;

    this.innerHTML = '<span class="bubblehouse-value-money__loading">Loading...</span>';

    if (window.Bubblehouse && window.Bubblehouse.data && window.Bubblehouse.data.authToken) {
      this.loadMonetaryBalance();
    }
  }

  handleBubblehouseLoad() {
    this.loadMonetaryBalance();
  }

  async loadMonetaryBalance() {
    try {
      // Check if we have required data
      if (!window.Bubblehouse || !window.Bubblehouse.data || !window.Bubblehouse.data.authToken) {
        console.warn('Bubblehouse auth token not available');
        this.innerHTML = '';
        return;
      }

      const authToken = window.Bubblehouse.data.authToken;
      const currentDomain = window.location.hostname;

      // Construct API URL
      const apiUrl = new URL(window.location.origin + '/apps/bubblehouse/blocks/rewards');
      apiUrl.searchParams.set('auth', authToken);
      apiUrl.searchParams.set('external_path', '/apps/bubblehouse/rewards/');
      apiUrl.searchParams.set('instance', 'bubblehouse-page');
      apiUrl.searchParams.set('market_domain', currentDomain);

      // Fetch the rewards page
      const response = await fetch(apiUrl.toString(), {
        method: 'GET',
        headers: {
          Accept: 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const htmlText = await response.text();

      // Parse the HTML and extract monetary balance
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const monetaryBalanceElement = doc.querySelector('.overview__monetary-balance-body');

      if (monetaryBalanceElement) {
        // Extract the inner HTML and set it to our element
        this.innerHTML = monetaryBalanceElement.innerHTML;

        // Add a class for styling
        this.classList.add('bubblehouse-value-money--loaded');
      } else {
        console.warn('Monetary balance element not found in Bubblehouse response');
        this.innerHTML = '';
      }
    } catch (error) {
      console.error('Error loading Bubblehouse monetary balance:', error);
      this.innerHTML = '';

      // Add error class for potential styling
      this.classList.add('bubblehouse-value-money--error');
    }
  }
}

// Register the custom element
if (!customElements.get('bubblehouse-value-money')) {
  customElements.define('bubblehouse-value-money', BubblehouseValueMoney);
}
